import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import Grid from '../Grid';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGrid = styled(Grid).withConfig({
  displayName: "CardComp__StyledGrid",
  componentId: "qnhbqs-0"
})(["&&{margin:0 0 0 0;}"]);
const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "CardComp__StyledCardWrapper",
  componentId: "qnhbqs-1"
})(["padding:28px 16px;border-radius:6px;box-shadow:0 8px 24px 0 rgba(45,62,80,0.12);&&{margin-top:36px;}"]);
const CardComp = ({
  children,
  testId
}) => {
  return /*#__PURE__*/_jsx(StyledCardWrapper, {
    children: /*#__PURE__*/_jsx(StyledGrid, {
      "data-test-id": testId,
      children: children
    })
  });
};
export default CardComp;